module.exports = "<div class=\"bg-light-purple\">\n  <app-dashboard></app-dashboard>\n</div>"